// extracted by mini-css-extract-plugin
export default {"Article":"Article_Article__bQ56O","upperCase":"Article_upperCase__IewhF","titleCase":"Article_titleCase__5P0iB"};